<template>
    <div>
        <div class="seachBox flex">
            <div class="seachList"><span class="name">更新日期：</span>
                <a-range-picker @keydown.enter.native="searchKey" class="seachs" v-model="seach.update_time" :allowClear="false" :showTime="false"
                                format="YYYY-MM-DD"/>
            </div>
            <div class="seachList"><span class="name">颜色：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.a_template_color_id" class="seachs" allowClear @keydown.enter.native="searchKey"  >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.colorList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">风格：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.a_template_style_id" class="seachs" allowClear @keydown.enter.native="searchKey" >
                    <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.styleList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
            <div class="seachList"><span class="name">编号：</span>
                <a-input placeholder="请输入编号" class="seachs" v-model="seach.code" @keydown.enter.native="searchKey" />
            </div>
            <div class="seachList"><span class="name">状态：</span>
<!--                placeholder="请选择"-->
                <a-select v-model="seach.status" class="seachs" allowClear @keydown.enter.native="searchKey" >
                    <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.statusList">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </div>
          <div class="seachList"><span class="name">订单报文：</span>
            <a-select v-model="seach.is_order_message" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.is_order_message">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
          <div class="seachList"><span class="name">代理模板：</span>
            <a-select v-model="seach.is_proxy" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.is_proxy">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>

          <div class="seachList"><span class="name">产品调取：</span>
            <a-select v-model="seach.product_page_data" class="seachs" allowClear @keydown.enter.native="searchKey" >
              <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.product_page_data">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
          <div class="seachList no"></div>
            <div class="seachBtnBox">
                <a-button type="primary" class="seachBtn" @click="getList(1)"> 查询</a-button>
                <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
        </div>
        <a-button class="top_btn" type="primary" @click="()=>{visible = true; title='添加模板' ;this.editId=''; }" v-has="'btn_add'"  >
            添加模板
        </a-button>
        <a-button class="top_btn" type="primary" @click="listOrder()" v-has="'btn_listorder'"> 排序</a-button>
      <a-button class="top_btn" type="primary" @click="exper" > 导出</a-button>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
                 :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"    :scroll="{ x: 1300 }">
            <span slot="list_order" slot-scope="text, record">
        <a-input   v-model="record.list_order" class="inputs" size="small"/>
            </span>
            <span slot="thumb" slot-scope="text, record">
                 <img  src="../../../assets/tem2.png" alt="" @click="()=>{visibleImg=true;tableImg=record.thumb}" style="width:30px;display: block;cursor: pointer">
      </span>

            <span slot="static_page" slot-scope="text, record">
        <a :href="`${urlBase}/${record.static_page.url}`" target="_blank">{{record.static_page.name}}</a>
      </span>
          <span slot="is_order_message" slot-scope="text, record">
         <a-switch   @click="onChange(record)"  :checked="text==1?true:false"/>
            </span>
          <span slot="is_proxy" slot-scope="text, record">
         <a-switch   @click="onChangeProxy(record)"  :checked="text==1?true:false"/>
            </span>

            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visible = true;; title='修改模板'; editId=text.id ; }" v-has="'btn_edit'">编辑<a-divider  type="vertical"/></a>
        <a @click="indexCont(text.id)" >首页内容<a-divider  type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"
          >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
                <TemplateForm :visible="visible" :title="title" :editId="editId" @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>
        <IndexContent :visible="visibleIndex" :title="title" :editIds="editIds" @changVisible=" () => { this.editIds='';this.visibleIndex = false; this.getList()}  "/>
        <a-modal  :footer="null"
                  title="查看大图"
                :visible="visibleImg"
                @cancel="()=>{visibleImg=false}"
        >
            <img :src="tableImg" alt="" style="width: 100%;display: block">
        </a-modal>
    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import TemplateForm from "./components/templateForm"
    import IndexContent from "./components/indexContent"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: "排序",
            dataIndex: "list_order",
            key: "list_order",
            width: "100px",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "编号",
            dataIndex: "code",
            width: "80px",
            ellipsis: true,
            key: "code"
        },
        {
            title: "缩略图",
            dataIndex: "thumb",
            ellipsis: true,
            width: "100px",
            key: "thumb",
            scopedSlots: {customRender: "thumb"}
        },
        {
            title: "静态页",
            dataIndex: "static_page",
            ellipsis: true,
            width: "100px",
            scopedSlots: {customRender: "static_page"},
            key: "static_page"
        },
        {
            title: "客户数",
            dataIndex: "customer_num",
            ellipsis: true,
            width: "100px",
            key: "customer_num"
        },
        {
            title: "颜色",
            dataIndex: "color_name",
            ellipsis: true,
            width: "100px",
            key: "color_name"
        },
        {
            title: "风格",
            dataIndex: "style_name",
            width: "150px",
            ellipsis: true,
            key: "style_name"
        },
        {
            title: "更新时间",
            dataIndex: "update_time",
            width: "150px",
            ellipsis: true,
            key: "update_time"
        },
        {
          title: "订单报文",
          key: "is_order_message",
          width: "90px",
          dataIndex: "is_order_message",
          scopedSlots: {customRender: "is_order_message"}
        },
      {
        title: "代理模板",
        key: "is_proxy",
        width: "90px",
        dataIndex: "is_proxy",
        scopedSlots: {customRender: "is_proxy"}
      },
      {
        title: "产品导航调取",
        key: "product_page_data_text",
        width: "120px",
        dataIndex: "product_page_data_text",
        scopedSlots: {customRender: "product_page_data_text"}
      },

      {
            title: "状态",
            key: "status_name",
            width: "80px",
            dataIndex: "status_name",
            scopedSlots: {customRender: "status_name"}
        },

        {
            title: "操作",
            key: "action",
            width: "170px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
              selectedRowKeys: [],
              urlBase:this.$store.state.urlExper,
                resetSeachdata:true,
                visibleImg:false,
                tableImg:"",
                seach: {
                    a_template_style_id: undefined,
                    code: "",
                    update_time: [],
                    a_template_color_id: undefined,
                    status:undefined,
                  is_order_message:undefined,
                  is_proxy:undefined,
                  product_page_data:undefined
                },
                seachList: {
                    styleList: [],
                    colorList: [],
                    statusList:[],
                  is_order_message:[],
                  is_proxy:[],
          product_page_data:[]
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                loading: true,
                visible: false,
                visibleIndex:false,
                title: "",
                editId: null,
                editIds:null,
                jurisdictionId: null,
                visibleJurisdiction: false,
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/TemplateManagement/TemplateListManagement"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
        },
        components:{TemplateForm,IndexContent},
        methods: {
          onChange(row) {
            let Json = {id: row.id, is_order_message: row.is_order_message == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS_MESSAGE, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
          onChangeProxy(row) {
            let Json = {id: row.id, is_proxy: row.is_proxy == 1 ? 2 : 1}
            changStatus(API.service.CHANG_STATUS_PROXY, [Json]).then(res => {
              if (res == true) {
                this.getList()
              }
            })

          },
            searchKey(){
                if(event.keyCode == 13){
                    this.getList(1)
                }
            },
            indexCont(id){
                this.visibleIndex = true
                this.title='首页内容';
                setTimeout(() => { this.editIds= id ; }, 300)
            },
            confirm(row) {
                removeById(API.service.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            listOrder() {
                let list_orders = []
                let sortListOrder = {id: "", list_order: ""}
                for (let i = 0; i < this.data.length; i++) {
                    sortListOrder.id = this.data[i].id
                    sortListOrder.list_order = this.data[i].list_order
                    list_orders.push(sortListOrder)
                    sortListOrder = {}
                }
                orderList(API.service.CHANG_STATUS, list_orders).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            resetSeach() {
                this.loading = true
                this.seach = {is_proxy:'',
                    a_template_style_id: "",
                    code: "",
                    update_time: this.seach.update_time.length>0?[moment(new Date(), 'YYYY-MM-DD'), moment(new Date(), 'YYYY-MM-DD')]:[],
                    a_template_color_id: "",
                  product_page_data:''
                }
                this.resetSeachdata=false
                this.getList(1)
            },
            getList(page) {
                let seachData=JSON.parse(JSON.stringify(this.seach))
                if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
                    seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
                    seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
                }else{
                    seachData.update_time=[]
                }
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.seachList.styleList = res.data.data.styleList
                    this.seachList.colorList = res.data.data.colorList
                    this.seachList.statusList = res.data.data.status
                    this.seachList.is_order_message = res.data.data.is_order_message
                  this.seachList.is_proxy = res.data.data.is_proxy
                  this.seachList.product_page_data = res.data.data.product_page_data

                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    if(!this.resetSeachdata==true)this.seach.update_time=[]
                    this.resetSeachdata=true
                    this.loading = false
                })
            },

          exper(id) {
            let seachData=JSON.parse(JSON.stringify(this.seach))


            if (seachData.update_time.length > 0&&this.resetSeachdata==true) {
              seachData.update_time[0] = moment(this.seach.update_time[0]).format('YYYY-MM-DD')
              seachData.update_time[1] = moment(this.seach.update_time[1]).format('YYYY-MM-DD')
            }else{
              seachData.update_time=[]
            }
            API.service.EXPORT({...seachData,ids:this.selectedRowKeys}).then(res => {
              window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
              // this.getList()
              // this.selectedRowKeys = []
            })
          },
          onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
          },
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name{width: 70px!important;}
    .seachBox .seachList .seachs{width: calc(100% - 80px);}
    .seachBox .seachBtnBox{position: static;margin-top: 0;text-align: right;padding-right: 10px;}
</style>
